var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{attrs:{"init":_vm.init,"id":_vm.id},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }